import React from 'react';
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { LANGUAGE_VERSIONS } from './constants';
import { IoIosArrowDown } from 'react-icons/io'

const languages = Object.entries(LANGUAGE_VERSIONS);
const ACTIVE_COLOR = 'blue.400';

const LanguageSelector = ({ language, onSelect }) => {
  return (
    <Box ml={2} mb={4}>
      <Text className='fs-5' mb={2} fontSize="lg">
        Language:
      </Text>
      <Menu isLazy>
        <MenuButton className='px-3 py-1 border rounded text-white bg-primary' as={Button}>{language}<IoIosArrowDown size="30px" className="px-2" /></MenuButton>
        <MenuList bg="white" zIndex={1}>
          {languages.map(([lang, version]) => (
            <MenuItem  className='px-4 py-1 border rounded Language_box'
              key={lang}
              color={lang === language ? ACTIVE_COLOR : ''}
              bg={lang === language ? 'gray.900' : 'transparent'}
              _hover={{
                color: ACTIVE_COLOR,
                bg: 'gray.900',
              }}
              onClick={() => onSelect(lang)}
            >
              {lang}
              &nbsp;
              <Text as="span" color="gray.600" fontSize="sm">
                ({version})
              </Text>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};

export default LanguageSelector;
